/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 TableRow — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviation: hover + selected backgroundColor via NS subtle-bg token
// (mode-aware) i.p.v. MUI default action.hover (alpha-mix op divider) en
// alpha(secondary.main, selectedOpacity).

export const MuiTableRowLightOverrides = {
  root: {
    color: 'inherit' as const,
    display: 'table-row' as const,
    verticalAlign: 'middle' as const,
    outline: 0,
    '&$hover:hover': {
      backgroundColor: 'var(--ns-color-bg-emphasis-secondary)',
    },
    '&$selected, &$selected:hover': {
      backgroundColor: 'var(--ns-color-bg-emphasis-secondary)',
    },
  },

  selected: {},
  hover: {},
  head: {},
  footer: {},
} as const;

// Dark variant — alle kleur-tokens zijn mode-aware via tokens.css.
export const MuiTableRowDarkOverrides = {
  ...MuiTableRowLightOverrides,
} as const;
